import { render, staticRenderFns } from "./SelectedNews.vue?vue&type=template&id=51c8cc2d&scoped=true&"
import script from "./SelectedNews.vue?vue&type=script&lang=js&"
export * from "./SelectedNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8cc2d",
  null
  
)

export default component.exports